//================================================================
//  Page: New Initiative
//================================================================

//  Purpose: Form for New Initiative or Technology

//================================================================

//Libraries
import React from 'react';

//Contexts

//Components

//Functions

//Images

//CSS

export default function NewInitiative({
    task
}) {
    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <div className='h-full flex flex-col gap-2'>

            {/* ============================ */}
            {/*          Questions           */}
            {/* ============================ */}

            <form className='flex flex-col gap-4'>

                {/*==================1. What is the name of the initiative / request? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 1. What is the name of the initiative / request? <span className='text-[#C4314B]'>*</span> </label>
                    <input
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        value={task?.initiativename}
                        type='text'
                    ></input>
                </div>

                {/*==================2. What is the application (if known)? =================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 2. What is the application (if known)? </label>
                    <input
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        value={task?.applicationname}
                        placeholder='Leave blank if unknown or not applicable'
                    ></input>
                </div>

                {/*==================3. What is the vendor's website (if known)? =================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 3. What is the vendor's website (if known)? </label>
                    <input
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        value={task?.vendorwebsite}
                        placeholder='Leave blank if unknown or not applicable'
                    ></input>

                </div>

                {/*==================4. What is the problem you are trying to solve? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 4. What is the problem you are trying to solve? <span className='text-[#C4314B]'>*</span> </label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        value={task?.problemstatement}
                    ></textarea>
                </div>

                {/*==================5. What is the outcome you are looking for? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 5. What is the outcome you are looking for? <span className='text-[#C4314B]'>*</span> </label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        value={task?.expectedoutcome}
                    ></textarea>
                </div>

                {/*==================6. What would be the impact if this didn't go ahead? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 6. What would be the impact if this didn't go ahead? <span className='text-[#C4314B]'>*</span> </label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        value={task?.businessimpact}
                    ></textarea>
                </div>

                {/*==================7. Is this a technology trial or a full implementation? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 7. Is this a technology trial or a full implementation? <span className='text-[#C4314B]'>*</span> </label>
                    <p className='italic font-light'>Note: Technology trials last no longer than 12 months. Interim reviews with the trial users take place at 3, 6 and 9 months. At the 9 month trial a decision must be made regarding the future of the application and  must be submitted via LoA approval processes. </p>
                    <select disabled className='Input-Field-Select'>
                        <option> {task?.implementationtype} </option>
                    </select>
                </div>

                {/*==================8. If this trial is successful, what would the next stage be? =================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 8. If this trial is successful, what would the next stage be? </label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        placeholder='Leave blank if unknown or not applicable'
                    ></textarea>
                </div>

                {/*==================9. Which business unit is driving this initiative? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 9. Which business unit is driving this initiative? <span className='text-[#C4314B]'>*</span> </label>
                    <select disabled className='Input-Field-Select'>
                        <option>{task?.businessunit}</option>
                    </select>
                </div>

                {/*==================10. Who are the primary end users of this initiative or application? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 10. Who are the primary end users of this initiative or application? <span className='text-[#C4314B]'>*</span> </label>
                    <select disabled className='Input-Field-Select'>
                        <option>{task?.primaryusers}</option>
                    </select>
                </div>

                {/*==================11. Which region(s) does this relate to? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 11. Which region(s) does this relate to? <span className='text-[#C4314B]'>*</span> </label>
                    <select disabled className='Input-Field-Select' style={{ height: '100px' }} value={task?.region} multiple>
                        <option hidden value=''>Select all that apply</option>
                        <option value='Australia'> Australia </option>
                        <option value='America'> America </option>
                        <option value='United Kingdom'> United Kingdom </option>
                        <option value='Italy'> Italy </option>
                        <option value='China'> China </option>
                        <option value='Malaysia'> Malaysia </option>
                        <option value='Japan'> Japan </option>
                        <option value='Singapore'> Singapore </option>
                    </select>
                </div>

                {/*==================12. Who is the Business Sponsor of this initiative? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 12. Who is the Business Sponsor of this initiative? <span className='text-[#C4314B]'>*</span> </label>

                    <input
                        disabled
                        className='Input-Field-Text w-full md:w-[450px]'
                        value={task?.businesssponsor?.email}
                    ></input>

                </div>

                {/*==================13. Who is your Line Manager? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 13. Who is your Line Manager? <span className='text-[#C4314B]'>*</span> </label>
                    <input
                        disabled
                        className='Input-Field-Text w-full md:w-[450px]'
                        value={task?.linemanager?.email}
                    ></input>
                </div>

                {/*==================14. Who will be the Finance Approver of this request? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 14. Who will be the Finance Approver of this request? <span className='text-[#C4314B]'>*</span> </label>
                    <p className='italic font-light'>Who will approve the cost onto your budget?</p>
                    <input
                        disabled
                        className='Input-Field-Text w-full md:w-[450px]'
                        value={task?.financemanager?.email}
                    ></input>
                </div>

                {/*==================15. What is the estimated cost of this request? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 15. What is the estimated cost of this request? <span className='text-[#C4314B]'>*</span> </label>
                    <p className='italic font-light'>Please enter your best guess or estimate in AUD. This value can be updated later.</p>
                    <input
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        type='number'
                        value={task?.estimatedcost}
                    ></input>
                </div>

                {/*==================16. Do you have budget for this request? *=================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 16. Do you have budget for this request? <span className='text-[#C4314B]'>*</span> </label>
                    <p className='italic font-light'>Do you have agreed budget available for this in your operating plan?</p>
                    <select disabled className='Input-Field-Select'>
                        <option>{task?.budgetavailable}</option>
                    </select>

                </div>

                {/*==================17. What is the cost code for this request? =================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 17. What is the cost code for this request?</label>
                    <p className='italic font-light'>Please enter the cost code for any recharges. You do not have to enter it now, but it may help to speed up the completion of your request.</p>
                    
                    {/* Project Code */}
                    <input 
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        placeholder='Project Code'
                        type='text'
                        value={task?.projectcode}
                    ></input>

                    {/* Project Name */}
                    <input 
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        placeholder='Project Name'
                        type='text'
                        value={task?.projectcodename}
                        hidden={task?.projectcodename === '' || task?.projectcodename === undefined}
                    ></input>

                    {/* Task Number */}
                    <input 
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        placeholder='Task Number'
                        type='text'
                        value={task?.tasknumber}
                    ></input>

                    {/* Expenditure Type */}
                    <input 
                        disabled
                        className='Input-Field-Text  md:w-[450px]'
                        placeholder='ICT Costs'
                        type='text'
                        value={task?.expendituretype}
                    ></input>

                </div>

                {/*==================18. Is there anything else important we should know? =================*/}
                <div className='Form-Row w-full'>
                    <label className='font-medium'> 18. Is there anything else important we should know?</label>
                    <p className='italic font-light'>e.g. Are there any time constraints or compliance/security issues? Is this a Client requirement? Will this replace an existing technology? </p>
                    <textarea disabled
                        className='Input-Field-TextArea'
                        placeholder='Leave blank if unknown or not applicable'
                        value={task?.otherinformation}
                    ></textarea>
                </div>

            </form>
        </div>
    )
}